import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8fdfaea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Text Files", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "loading"
}
const _hoisted_6 = {
  key: 1,
  class: "error"
}
const _hoisted_7 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_8 = { class: "file-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "file-actions" }
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })
], -1))
const _hoisted_19 = {
  key: 0,
  class: "file-content"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "7 3 7 8 15 8" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-content",
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          class: "close-button"
        }, _hoisted_4)
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading..."))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.id,
                    class: "file-item"
                  }, [
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.selectFile(file)),
                      class: _normalizeClass({ 'selected': _ctx.selectedFile?.id === file.id })
                    }, _toDisplayString(file.name), 11, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.renameFile(file)),
                        disabled: _ctx.isProcessing,
                        class: "icon-button"
                      }, _hoisted_13, 8, _hoisted_11),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeFile(file)),
                        disabled: _ctx.isProcessing,
                        class: "icon-button"
                      }, _hoisted_16, 8, _hoisted_14)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewFile && _ctx.addNewFile(...args))),
                  disabled: _ctx.isProcessing,
                  class: "add-file-button"
                }, [
                  _hoisted_18,
                  _createTextVNode(" Add New File ")
                ], 8, _hoisted_17)
              ]),
              (_ctx.selectedFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.selectedFile.name), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFile.content) = $event)),
                      rows: "10",
                      disabled: _ctx.isProcessing
                    }, null, 8, _hoisted_20), [
                      [_vModelText, _ctx.selectedFile.content]
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveFileContent && _ctx.saveFileContent(...args))),
                      disabled: _ctx.isProcessing,
                      class: "save-button"
                    }, [
                      _hoisted_22,
                      _createTextVNode(" Save Changes ")
                    ], 8, _hoisted_21)
                  ]))
                : _createCommentVNode("", true)
            ]))
    ])
  ]))
}